var map = {
	"./search-da-dk.avif": 67431,
	"./search-de-de.avif": 56297,
	"./search-en-gb.avif": 37789,
	"./search-en-us.avif": 9978,
	"./search-es-es.avif": 39977,
	"./search-es-mx.avif": 53374,
	"./search-fr-fr.avif": 3812,
	"./search-it-it.avif": 71100,
	"./search-nb-no.avif": 47686,
	"./search-nl-nl.avif": 24997,
	"./search-pl-pl.avif": 80108,
	"./search-pt-br.avif": 19840,
	"./search-pt-pt.avif": 47952,
	"./search-sv-se.avif": 22974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80117;